import DecimalType from "decimal.js";

/** Helper constructor that ensures decimals have the correct precision and rounding mode */
export const Decimal = DecimalType.clone({
  precision: 20,
  rounding: DecimalType.ROUND_HALF_UP,
});

export const D_ZERO = new Decimal(0);
export const D_HUNDRED = new Decimal(100);
export const CURRENCY_DECIMALS = 2;

/** @returns a+b */
export function decimalAdd(
  a: DecimalType,
  b: DecimalType,
): DecimalType {
  return a.plus(b);
}

export function toCurrencyDecimals(
  decimal: DecimalType,
  rounding?: DecimalType.Rounding,
): DecimalType;
export function toCurrencyDecimals(
  decimal: undefined,
  rounding?: DecimalType.Rounding,
): undefined;
export function toCurrencyDecimals(
  decimal: DecimalType | undefined,
  rounding?: DecimalType.Rounding,
): DecimalType | undefined;
export function toCurrencyDecimals(
  decimal: DecimalType | undefined,
  rounding: DecimalType.Rounding = DecimalType.ROUND_HALF_UP,
): DecimalType | undefined {
  if (!decimal) {
    return undefined;
  }
  return decimal.toDecimalPlaces(CURRENCY_DECIMALS, rounding);
}

export function toCurrencyDecimalsString(
  decimal: DecimalType,
  rounding?: DecimalType.Rounding,
): string;
export function toCurrencyDecimalsString(
  decimal: undefined,
  rounding?: DecimalType.Rounding,
): undefined;
export function toCurrencyDecimalsString(
  decimal: DecimalType | undefined,
  rounding?: DecimalType.Rounding,
): string | undefined;
export function toCurrencyDecimalsString(
  decimal: DecimalType | undefined,
  rounding: DecimalType.Rounding = DecimalType.ROUND_HALF_UP,
): string | undefined {
  if (!decimal) {
    return undefined;
  }
  return decimal.toFixed(CURRENCY_DECIMALS, rounding);
}

export function roundToNearest(
  decimal: DecimalType,
  nearest: number,
): DecimalType {
  return decimal.div(nearest).round().times(nearest);
}
